<!-- eslint-disable -->
<template lang="pug">
    .room
        img.detective__background(:src='backgroundImg')
        .columns.detective__interlocutors
            .column.left-interlocutor
                img(
                    v-if="sceneName === 'seventhLetter' || sceneName === 'eighthLetter'",
                    style='transform: rotateY(180deg)',
                    src='../../../../assets/images/detective/chapter_1/right_interlocutor/detective_with_closed_bag.png'
                )
            transition(name='bounce')
                img.interactive-block.interactive-block_with-letter(
                    v-if='isElementClickable',
                    :src='letterSrc',
                    :class="'interactive-block__' + sceneName"
                )
            .interactive-block.interactive-block__help-text(
                v-if='isElementClickable',
                :class=`{
                    'interactive-block__help-text_blue': ['thirdLetter', 'fourthLetter', 'seventhLetter', 'eighthLetter'].includes(sceneName),
                    'interactive-block__help-text_red': ['fifthLetter', 'sixthLetter'].includes(sceneName)
                }`
            )
                | {{ $i18n.t('detective.detective_interactive_clickOnElement') }}
            .column.center-column(:style="isNeedCentering(sceneName)")
                slot(v-if='!isElementClickable && isAnimationFinished')
            .column.right-interlocutor
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            items: Array,
            sceneName: {
                type: String,
                default: 'firstLetter'
            },
            isMobile: Boolean,
            isElementClickable: {
                type: Boolean,
                default: false
            },
            isAnimationFinished: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            isNeedCentering (sceneName) {
                if (['firstLetter', 'secondLetter'].includes(sceneName) && !this.isMobile ) {
                    return 'padding-left: 15%'
                } else if (['seventhLetter', 'eighthLetter'].includes(sceneName) && !this.isMobile ) {
                    return 'padding-right: 25%';
                }
                return '';
            },
        },
        computed: {
            backgroundImg () {
                switch (this.sceneName) {
                    case 'firstLetter':
                    case 'secondLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_1.png');
                    case 'thirdLetter':
                    case 'fourthLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_2.png');
                    case 'fifthLetter':
                    case 'sixthLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_3.png');
                    case 'seventhLetter':
                    case 'eighthLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_4.png');
                }
            },
            letterSrc () {
                return require('../../../../assets/images/detective/chapter_2/letters/' + this.sceneName.split('Letter')[0] + '.png');
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/detective/conversation-modal.scss";

    .detective__background, .detective__interior {
      position: absolute;
      height: 100vh;
      width: 100%;
    }

    .detective__interlocutors, .detective__shadows {
      position: absolute;
      height: 100vh;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .center-column {
        width: 25%;
        margin: 0 auto;
        position: relative;
    }

    .conversation-block {
        height: auto;
        overflow: hidden;
        margin-bottom: 20rem;
    }

    .room {
        display: flex;
        justify-content: center;
        height: 100vh;
        width: 100%;
        overflow: hidden;
    }

    .left-interlocutor {
        flex-direction: column;
        justify-content: flex-end !important;
        img {
            height: 84.7vh;
        }
    }

    .right-interlocutor {
        flex-direction: column !important;
        align-items: flex-start !important;
        justify-content: flex-end !important;
    }

    .interactive-block {
        position: absolute;
        z-index: 1;
        &_with-letter {
            width: 4vh;
            height: 6vh;
            @include media($sm) {
                width: 3vh;
                height: 5vh;
            }
            @include media($lg) {
                width: 4vh;
                height: 6vh;
            }
        }
        &__firstLetter {
            top: 42%;
            left: 50%;
        }
        &__secondLetter {
            left: 14%;
            top: 7%;
        }
        &__thirdLetter {
            top: 16%;
            left: 31%;
        }
        &__fourthLetter {
            top: 19%;
            left: 81%;
        }
        &__fifthLetter {
            top: 8%;
            left: 23%;
        }
        &__sixthLetter {
            top: 76%;
            left: 90%;
        }
        &__seventhLetter {
            top: 9%;
            left: 48%;
        }
        &__eighthLetter {
            top: 14%;
            left: 27%;
        }
        &__help-text {
            font-family: Boomboom, serif;
            color: #ff8f1f;
            text-align: center;
            white-space: nowrap;
            left: 30%;
            font-size: 22px;
            @include media($sm) {
                font-size: 36px;
            }
            @include media($md) {
                font-size: 46px;
            }
            &_blue {
                color: rgb(27, 78, 120);
            }
            &_red {
                color: rgb(255, 56, 96);
            }
        }
    }

    .bounce-leave-active {
        animation: bounce-in .9s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(2);
        }
        100% {
            transform: scale(1);
        }
    }
</style>
